import { IconChat, IconShieldCheck, IconShieldBlock, IconHeart, IconSparkle, IconUsers } from "../components/icons";

// NotificationType (يطابق enum الباك اند بعد التعديل ليترجع كنص):
// ChatRequestReceived | ChatRequestAccepted | ChatRequestRejected | NewMessage | SystemMessage | ProfileVisited
export function getNotificationMeta(type, content = "") {
  switch (type) {
    case "ChatRequestReceived":
      return { icon: IconHeart, bg: "bg-primary-50", color: "text-primary-500" };
    case "ChatRequestAccepted":
      return { icon: IconShieldCheck, bg: "bg-green-50", color: "text-green-600" };
    case "ChatRequestRejected":
      return { icon: IconShieldBlock, bg: "bg-red-50", color: "text-red-400" };
    case "NewMessage":
      return { icon: IconChat, bg: "bg-blue-50", color: "text-blue-500" };
    case "ProfileVisited":
      return { icon: IconUsers, bg: "bg-purple-50", color: "text-purple-500" };
    default:
      // احتياطي للبيانات القديمة: حاول تخمّن الأيقونة الأنسب من نص الإشعار
      if (content.includes("طلب محادثة")) return { icon: IconHeart, bg: "bg-primary-50", color: "text-primary-500" };
      if (content.includes("رسالة")) return { icon: IconChat, bg: "bg-blue-50", color: "text-blue-500" };
      if (content.includes("زيارة")) return { icon: IconUsers, bg: "bg-purple-50", color: "text-purple-500" };
      return { icon: IconSparkle, bg: "bg-yellow-50", color: "text-gold-600" };
  }
}

// يحدد وجهة التنقل المناسبة عند الضغط على الإشعار
export function getNotificationLink(notification, langPrefix = "") {
  if (notification.type === "ChatRequestReceived") return `${langPrefix}/chat-requests`;
  if (notification.type === "NewMessage") return `${langPrefix}/chat`;
  if (notification.type === "ChatRequestAccepted" || notification.type === "ChatRequestRejected" || notification.type === "ProfileVisited") {
    return notification.relatedUserId ? `${langPrefix}/profile/${notification.relatedUserId}` : null;
  }

  // احتياطي: لو نوع الإشعار مش متطابق مع أي حالة معروفة (بيانات قديمة من نسخة سابقة مثلاً)،
  // حاول تحدد الوجهة الصحيحة من نص الإشعار نفسه بدل ما ترجع لصفحة غلط
  const content = notification.content || "";
  if (content.includes("طلب محادثة")) return `${langPrefix}/chat-requests`;
  if (content.includes("رسالة")) return `${langPrefix}/chat`;
  if (notification.relatedUserId) return `${langPrefix}/profile/${notification.relatedUserId}`;
  return null;
}
